Application.modal = null;
Application.mask = null;
Application.modal2 = null;
Application.mask2 = null;

Application.parentModalClose = function() {
  if(parent && parent.Application.MODAL) {
      parent.Application.MODAL.callback();
  }
};

Application.parentModal2Close = function() {
    if(parent && parent.Application.MODAL2) {
        parent.Application.MODAL2.callback();
    }
};

Application.MODAL = function () {
    var modalCallback = {};

    var defaultCss = {
        width: null,
        height: null,
        position: {
            left: "center",
            top: "middle"
        }
    };

    var defaultOption = $.extend(true, {}, defaultCss, {
        iframeLoadingMsg: "",
        iframe: {
            method: "get",
            url: "#"
        },
        closeToEsc: true,
        onStateChanged: function onStateChanged() {
            // mask
            if (this.state === "open") {
                Application.MASK.open();
            } else if (this.state === "close") {
                Application.MASK.close();
            }
        },
        animateTime: 100,
        zIndex: 1001,
        absolute: false,
        fullScreen: false,
        header: {
            title: "새로운 윈도우",
            btns: {
                close: {
                    label: '<i class="far fa-times"></i>', onClick: function onClick() {
                        Application.MODAL.callback();
                    }
                }
            }
        }
    });

    var open = function (modalConfig) {

        modalConfig = $.extend(true, {}, defaultOption, modalConfig);
        $(document.body).addClass("modalOpened");

        this.modalCallback = modalConfig.callback;
        this.modalSendData = modalConfig.sendData;
        if(modalConfig.width == null) {
            modalConfig.width = '100vw';
        } else {
            if(modalConfig.width > $(window).width()) {
                modalConfig.width = '90vw';
            }
        }
        if(modalConfig.height == null) {
            modalConfig.height = '100vh';
        } else {
            if(modalConfig.height > $(window).height()) {
                modalConfig.height = '90vh';
            }
        }
        Application.modal.open(modalConfig);
    };

    var css = function css(modalCss) {
        modalCss = $.extend(true, {}, defaultCss, modalCss);
        Application.modal.css(modalCss);
    };
    var align = function align(modalAlign) {
        Application.modal.align(modalAlign);
    };
    var close = function close(data) {
        Application.modal.close();
        setTimeout(function () {
            $(document.body).removeClass("modalOpened");
        }, 500);
    };
    var minimize = function minimize() {
        Application.modal.minimize();
    };
    var maximize = function maximize() {
        Application.modal.maximize();
    };
    var callback = function callback(data) {
        if (this.modalCallback) {
            this.modalCallback(data);
        }
        this.close(data);
    };
    var getData = function getData() {
        if (this.modalSendData) {
            return this.modalSendData();
        }
    };

    return {
        "open": open,
        "css": css,
        "align": align,
        "close": close,
        "minimize": minimize,
        "maximize": maximize,
        "callback": callback,
        "modalCallback": modalCallback,
        "getData": getData
    };
}();

Application.MODAL2 = function () {
    var modalCallback = {};

    var defaultCss = {
        width: null,
        height: null,
        position: {
            left: "center",
            top: "middle"
        }
    };

    var defaultOption = $.extend(true, {}, defaultCss, {
        iframeLoadingMsg: "",
        iframe: {
            method: "get",
            url: "#"
        },
        closeToEsc: true,
        onStateChanged: function onStateChanged() {
            // mask
            if (this.state === "open") {
                Application.MASK2.open();
            } else if (this.state === "close") {
                Application.MASK2.close();
            }
        },
        animateTime: 100,
        zIndex: 1001,
        absolute: false,
        fullScreen: false,
        header: {
            title: "새로운 윈도우",
            btns: {
                close: {
                    label: '<i class="far fa-times"></i>', onClick: function onClick() {
                        Application.MODAL2.callback();
                    }
                }
            }
        }
    });

    var open = function (modalConfig) {

        modalConfig = $.extend(true, {}, defaultOption, modalConfig);
        $(document.body).addClass("modalOpened");

        this.modalCallback = modalConfig.callback;
        this.modalSendData = modalConfig.sendData;
        if(modalConfig.width == null) {
            modalConfig.width = $(window).width();
        } else {
            if(modalConfig.width > $(window).width()) {
                modalConfig.width = $(window).width() * 0.9;
            }
        }
        if(modalConfig.height == null) {
            modalConfig.height = $(window).height();
        } else {
            if(modalConfig.height > $(window).height()) {
                modalConfig.height = $(window).height() * 0.9;
            }
        }
        Application.modal2.open(modalConfig);
    };

    var css = function css(modalCss) {
        modalCss = $.extend(true, {}, defaultCss, modalCss);
        Application.modal2.css(modalCss);
    };
    var align = function align(modalAlign) {
        Application.modal2.align(modalAlign);
    };
    var close = function close(data) {
        Application.modal2.close();
        setTimeout(function () {
            $(document.body).removeClass("modalOpened");
        }, 500);
    };
    var minimize = function minimize() {
        Application.modal2.minimize();
    };
    var maximize = function maximize() {
        Application.modal2.maximize();
    };
    var callback = function callback(data) {
        if (this.modalCallback) {
            this.modalCallback(data);
        }
        this.close(data);
    };
    var getData = function getData() {
        if (this.modalSendData) {
            return this.modalSendData();
        }
    };

    return {
        "open": open,
        "css": css,
        "align": align,
        "close": close,
        "minimize": minimize,
        "maximize": maximize,
        "callback": callback,
        "modalCallback": modalCallback,
        "getData": getData
    };
}();

$(function () {
    Application.MASK = new ax5.ui.mask({
        zIndex: 1000
    });
    Application.modal = new ax5.ui.modal({
        absolute: true,
        iframeLoadingMsg: '<i class="far fa-spinner"></i>'
    });
    Application.MASK2 = new ax5.ui.mask({
        zIndex: 1000
    });
    Application.modal2 = new ax5.ui.modal({
        absolute: true,
        iframeLoadingMsg: '<i class="far fa-spinner"></i>'
    });
});